/**
 * DevExtreme (esm/__internal/grids/new/grid_core/selection/const.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var SelectionMode;
! function(SelectionMode) {
    SelectionMode.Multiple = "multiple";
    SelectionMode.Single = "single";
    SelectionMode.None = "none"
}(SelectionMode || (SelectionMode = {}));
export var ShowCheckBoxesMode;
! function(ShowCheckBoxesMode) {
    ShowCheckBoxesMode.Always = "always";
    ShowCheckBoxesMode.OnClick = "onClick";
    ShowCheckBoxesMode.OnLongTap = "onLongTap";
    ShowCheckBoxesMode.None = "none"
}(ShowCheckBoxesMode || (ShowCheckBoxesMode = {}));
